import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import tab1 from '../../assets/parents/tab1.svg';
import tab2 from '../../assets/parents/tab2.svg';
// import tab3 from '../../assets/parents/tab3.svg';

const tabsData = [
  {
    id: 'anxiety',
    label: 'Математична тривожність',
    icon: tab1,
    content: [
      { text: "Відео", bgColor: "#E95E2A", color: '#FFFFFF' },
      { text: "Поради", bgColor: "#F4B7EA", color: '#1E1E1E' },
      { text: "Дослідження", bgColor: "#0F2D4D", color: '#FFFFFF' },
    ]
  },
  {
    id: 'home-game',
    label: 'Ігри вдома',
    icon: tab2,
    content: [
      { text: "Гра 1", bgColor: "#E95E2A", color: '#FFFFFF' },
      { text: "Гра 2", bgColor: "#F4B7EA", color: '#1E1E1E' },
      { text: "Гра 3", bgColor: "#0F2D4D", color: '#FFFFFF' },
    ]
  },
  // {
  //   id: 'board-games',
  //   label: 'Настільні ігри',
  //   icon: tab3,
  //   content: [
  //     { text: "", bgColor: "#E95E2A", color: '#FFFFFF' },
  //     { text: "", bgColor: "#F4B7EA", color: '#1E1E1E' },
  //     { text: "", bgColor: "#0F2D4D", color: '#FFFFFF' },
  //   ]
  // },
];

export default function TabsSection () {
  const [activeTab, setActiveTab] = useState(tabsData[0]);

  return (
    <section className="tabs-container">
      <div className="tabs-nav">
        {tabsData.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab)}
            className={`tab-button ${activeTab.id === tab.id ? 'active' : ''}`}
          >
            <img src={tab.icon} alt="" className="tab-icon"/>
            {tab.label}
            
            {activeTab.id === tab.id && (
              <motion.div 
                layoutId="activeTabLine" 
                className="active-line" 
              />
            )}
          </button>
        ))}
      </div>

      <div className="tabs-content">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab.id}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            className="instruction-grid"
          >
            {activeTab.content.map((item, index) => (
              <div 
                key={index} 
                className="instruction-card" 
                style={{ backgroundColor: item.bgColor, color: item.color }}
              >
                <p>{item.text}</p>
              </div>
            ))}
          </motion.div>
        </AnimatePresence>
      </div>
    </section>
  );
};